<template>
  <!-- template for the modal component -->
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="configuracion.bg_color +' '+ configuracion.text_color">
          <div class="modal-body">
            <slot name="body">
              <div class="grid grid-cols-5">
                <div class="col-span-4 pt-2 text-center">
                  <span class="text-center font-bold text-lg">{{ message }}</span>
                </div>
                 <div class="text-right">
                   <slot name="cerrar">
                     <span class="text-right text-4xl">x</span>
                   </slot>
                 </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    value: false,
    message: {
      type: String,
      default: 'Mensaje de alerta'
    },
  },
  data: () => ({
    configuracion: {
        text_color: 'text-white',
        bg_color: 'bg-blue-200',
    },
  })
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 30px 30px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}


/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>